import * as types from "../actions/actionTypes"
const initialState = {
	loading:true,
	selectedTab: '',
	data: { data: [], links: {}, message: [], meta: {} }
};

const AccountReview = (state = initialState, action) => {
	switch (action.type) {
		case types.API_CALL_ACCOUNT_REVIEW_REQUEST:
			return { ...state, loading: true, selectedTab: '' };
		case types.PUT_ACCOUNT_REVIEW:
			return { ...state, ...action.payLoad };
		case types.SELECTED_TAB_ACCOUNT_REVIEW:
			return { ...state, selectedTab: action.selectedTab };
		default:
			return state;
	}
};

export default AccountReview;